import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { MainService } from 'BaseServices/main-service';
import {
  EquipmentDetailDTO,
  IsServiceOkDTO
} from 'projects/EquipmentRegistration/src/equipment-registration-base/dataTypes';

@Component({
  selector: 'app-equipment-home-tab',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './equipment-home-tab.component.html',
  styleUrls: ['./equipment-home-tab.component.css'],
})
export class EquipmentHomeTabComponent implements OnInit {
  equipmentId = 0;
  hasEquipmentImage = false;
  equipmentImageSrc: string | null = null;

  equipment = {
    id: 0,
    name: '',
    subcategoryName: '',
    model: '',
    isServiceOKText: '',
    lastControlType: '',
    comment: '',
    lastServiceComment: '',
  };

  readonly isServiceOkLabel: Record<number, string> = {
    [IsServiceOkDTO.OK]: 'OK',
    [IsServiceOkDTO.IkkeKontrolleret]: 'Ikke kontrolleret',
    [IsServiceOkDTO.Defekt]: 'Defekt',
  };

  constructor(
    private activatedRoute: ActivatedRoute,
    private mainService: MainService
  ) { }

  ngOnInit(): void {
    this.activatedRoute.parent?.paramMap.subscribe((params) => {
      this.equipmentId = Number(params.get('id') ?? 0);

      if (!this.equipmentId) return;

      this.loadEquipment(this.equipmentId);
    });
  }

  private loadEquipment(id: number): void {
    this.mainService.get<EquipmentDetailDTO>('Equipment', id).subscribe({
      next: (equipment) => {
        this.populateForm(equipment);
      },
      error: (err) => {
        console.error('Could not load equipment', err);
      },
    });
  }

  private populateForm(equipment: EquipmentDetailDTO): void {
    const eq: any = equipment;

    const serviceOkValue = Number(
      eq.IsServiceOK ??
      eq.isServiceOK ??
      eq.IsServiceOk ??
      eq.isServiceOk ??
      IsServiceOkDTO.IkkeKontrolleret
    );

    const id = Number(eq.Id ?? eq.id ?? 0);

    this.hasEquipmentImage = !!(eq.EquipmentImage ?? eq.equipmentImage);

    if (this.hasEquipmentImage) {
      this.equipmentImageSrc = `/api/Equipment/${id}/equipment-image`;
    } else {
      this.equipmentImageSrc = null;
    }


    this.equipment = {
      id: Number(eq.Id ?? eq.id ?? 0),
      name: String(eq.Name ?? eq.name ?? ''),
      subcategoryName: String(
        eq.subCategoryName ??
        eq.SubcategoryName ??
        eq.subcategoryName ??
        eq.Subcategory?.Name ??
        eq.Subcategory?.name ??
        ''
      ),
      model: String(eq.Model ?? eq.model ?? ''),
      isServiceOKText: this.isServiceOkLabel[serviceOkValue] ?? '',
      lastControlType: String(eq.LastServiceType ?? eq.lastServiceType ?? ''),
      comment: String(eq.Comment ?? eq.comment ?? ''),
      lastServiceComment: String(eq.LastServiceComment ?? eq.lastServiceComment ?? ''),
    };
  }
}
